import Splide from "@splidejs/splide";
import Video from "@splidejs/splide-extension-video";

class RelatedGallery {
  init(args = {}) {
    this.args = args;
    this.relatedGallery = document.querySelector('.js-related-gallery')
    this.relatedGalleryClass = '.js-gallery-image';
    this.relatedGalleryThumbClass = '.js-gallery-thumbs';
    // console.log('Args: ' + this.args);
    // console.log('Related Gallery: ' + this.relatedGallery);
    // console.log('Related Gallery Class: ' + this.relatedGalleryClass);
    // console.log('Related Gallery Thumb Class: ' + this.relatedGalleryThumbClass);

    if (this.relatedGallery) {
      // console.log('Related Slider set');
      this.setSlider();
    }
  }

  isSingle() {
    return document.querySelector('body').classList.contains('single-product');
  }

  setSlider() {
    let optionsThumbs = {
      rewind: true,
      fixedHeight: 190,
      isNavigation: true,
      gap: 0,
      focus: 'center',
      pagination: false,
      cover: true,
      perPage: 5,
      arrows: false,
      breakpoints: {
        '600': {
          fixedWidth: 190,
          fixedHeight: 190,
        }
      }
    }

    optionsThumbs = Object.assign(optionsThumbs, this.args.optionsThumbs);

    let relatedSecondarySlider = new Splide(this.relatedGalleryThumbClass, optionsThumbs);


    let optionsMain = {
      type: 'fade',
      heightRatio: 1,
      pagination: false,
      cover: true,
      gap: 0,
      fixedHeight: 790,
      breakpoints: {
        '768': {
          fixedHeight: this.isSingle() ? 456 : 300,
          pagination: true,
        }
      }
    };
    optionsMain = Object.assign(optionsMain, this.args.optionsMain);

    // let primarySlider = new Splide(this.galleryClass, optionsMain).mount({Video});
    let relatedSlider = new Splide(this.relatedGalleryClass, optionsMain).mount({Video});

    if (window.innerWidth > 768) {
      relatedSecondarySlider.mount()
      // primarySlider.sync(relatedSecondarySlider).mount();
      relatedSlider.sync(relatedSecondarySlider).mount();
    } else {
      //primarySlider.mount();
      relatedSlider.mount();
    }
  }
}

export default RelatedGallery;
